<template>
  <v-container class="px-10" fluid>
    <v-popup-loading :isLoading="isLoadingBranch" />
    <snack-bar v-model="isCreateSuccess" :content="snackbarSuccess"></snack-bar>
    <snack-bar
      v-model="isCreateFail"
      :content="snackbarFail"
      type="error"
    ></snack-bar>
    <alert-confirm
      :show="isDelete"
      title="Remove Confirmation"
      subTitle="Are you sure you want to remove this Symptomatic Areas? This action will remove content in both Thai and English."
      :close="closeDialog"
      headline-color="black"
      buttonText="Remove"
      :confirm="confirmDialog"
      icon=""
    ></alert-confirm>
    <edit-order-dialog
      :show="isEditOrder"
      :data="editOrderObject"
      :close="closeEditOrder"
      title-key="name"
      @save="saveEditOrder"
    ></edit-order-dialog>
    <v-row>
      <v-col>
        <v-breadcrumbs
          :items="breadcrumbs"
          divider=">"
          class="px-0"
        ></v-breadcrumbs>
        <div class="d-flex justify-space-between">
          <h3 class="pageHeadline" t-data="page-headline">Symptomatic Areas</h3>
          <v-btn
            id="add-btn"
            v-if="hasPermCreate()"
            large
            color="primary600Color"
            @click="create"
            class="white-text-button button-bold"
            t-data="create-btn"
          >
            <v-icon left>mdi-plus-circle-outline</v-icon>Create Symptomatic Areas
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-card>
      <v-card-title :class="{'mb-0': true, 'pb-0': isSelectedBranch}">
        <v-row>
          <v-col cols="12" sm="4" class="mt-0 pt-0 pb-0">
            <single-selected-branch
              outlined
              required
              dense
              title="Branch"
              :branch="branches"
              :selectedBranch="selectedBranch"
              :syncData="changedSelectedBranch"
              :rule="v => !!v || 'Please select branch'"
            ></single-selected-branch>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-title class="pt-0 pb-2" v-if="showSearchAndFilter">
        <v-row>
          <v-col class="pt-0 pb-0" cols="12" sm="4" t-data="search-panel">
            <search
              :key="componentKey"
              :search="filters.searchPhase"
              label="Search by Title"
              @enter="textSearch"
              @clear="clearSearch()"
            ></search>
          </v-col>
          <v-col class="pt-0 pb-0" cols="12" sm="6"></v-col>
          <v-col
            cols="12"
            sm="2"
            class="d-flex justify-end align-center pt-0 pb-0"
            t-data="filter-panel"
          >
            <filter-dropdown :key="componentKey" @apply="handleApplyFilter"></filter-dropdown>
          </v-col>
        </v-row>
      </v-card-title>
      <v-tabs
        v-if="isSelectedBranch"
        v-model="tab"
        class="status-tab fix-height-tab body-regular"
        color="primary500Color"
        slider-color="primary500Color"
        align-with-title
        @change="fetchByTab"
      >
        <v-tab class="fix-width-tab" v-for="item in tabItems" :key="item">
          {{ item }}
        </v-tab>
        <v-tab-item>
          <v-layout fluid v-resize="onResize">
            <v-data-table
              :loading="isLoading"
              :options.sync="options"
              :headers="table.activeHeaders"
              :items="symptomaticAreasList"
              :items-per-page="table.pageSize"
              :server-items-length="total"
              :footer-props="{'items-per-page-options': table.itemPerPages}"
              :sort-desc="true"
              :must-sort="false"
              class="elevation-1 custom-table"
              fixed-header
              style="width: 100%"
              :height="
                windowSize.y - heightOptions.header - heightOptions.tableFooter
              "
            >
              <template v-slot:item.content="{item}">
                <tooltip-title :contents="item.contents" key-name="name">
                  <template v-slot:content>
                <v-list-item-content
                  class="d-inline-block text-truncate"
                  style="width: 265px"
                >
                  <v-list-item-title>
                    {{ getContentByLang(item.contents, 'th') }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ getContentByLang(item.contents, 'en') }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
                </tooltip-title>
              </template>
              <template v-slot:item.org="{item}">{{
                listBranch(item.org)
              }}</template>
              <template v-slot:item.update_date="{item}">{{
                dateFmt(item.update_date)
              }}</template>
              <template v-slot:item.update_by_user="{item}">
                <username-status-text :user="item.update_by_user" />
              </template>
              <template v-slot:item.status="{item}" style="width: 82px">
                <v-switch
                  t-data="status-switch"
                  color="primary200Color"
                  v-model="item.status"
                  :false-value="inActiveStatus"
                  :true-value="activeStatus"
                  :disabled="!hasPermEditByOrg(item.org)"
                  @change="event => handleSwitchStatusChange(event, item.id)"
                  class="mb-0 pb-0 custom-switch"
                ></v-switch>
              </template>
              <template v-slot:item.actions="{item}">
                <v-icon
                  t-data="edit-action"
                  class="px-2 action-icon"
                  @click="actionEdit(item)"
                  >mdi-pencil-outline</v-icon
                >
                <v-icon
                  t-data="delete-action"
                  class="px-2 action-icon"
                  v-if="hasPermDeleteByOrg(item.org)"
                  @click="actionDelete(item)"
                  >mdi-trash-can-outline</v-icon
                >
                <v-icon
                  v-else
                  t-data="empty-icon"
                  class="px-2 action-icon transparent-icon"
                ></v-icon>
              </template>
            </v-data-table>
          </v-layout>
          <div
            class="table-footer-prepend"
            t-data="total-result-content"
            v-if="isSelectedBranch"
          >
            <div class="vertical-center pl-4">
              <b>{{ total }}</b> Search results
            </div>
          </div>
        </v-tab-item>
        <v-tab-item>
          <sortable-table
            @updateSuccess="showSuccessSnackbar(actionEnumData.STATUS_UPDATED)"
            @updateFail="showFailSnackbar(actionEnumData.STATUS_UPDATED)"
          ></sortable-table>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-container>
</template>

<script>
import TooltipTitle from '@/components/TooltipTitle'
import EditOrderDialog from '@/components/EditOrderDialog'
import {mapState, mapActions} from 'vuex'
import {
  convertDate,
  hasPermision,
  hasPermissionsByOrgs,
  searchHandler,
  snackbarFailContent,
  snackbarSuccessContent,
  swapArrayElements
} from '../../helper/helper'
import AlertConfirm from '../../components/AlertConfirm'
import SnackBar from '@/components/SnackBar'
import FilterDropdown from '@/views/symptomatic-areas/FilterDropdown'
import Search from '@/components/Search'
import SingleSelectedBranch from '@/components/SingleSelectedBranch'
import {symptomaticAreasStatusEnum} from '@/constants/symptomatic-areas'
import {actionEnum, tabEnum} from '@/constants/constants'
import PopupLoading from '@/components/PopupLoading'
import UsernameStatusText from '@/components/UsernameStatusText'
import SortableTable from '@/components/symptomatic-areas/SortableTable'

export default {
  created() {
    this.textSearch()
  },
  components: {
    'v-popup-loading': PopupLoading,
    AlertConfirm,
    EditOrderDialog,
    FilterDropdown,
    Search,
    SingleSelectedBranch,
    SnackBar,
    SortableTable,
    TooltipTitle,
    UsernameStatusText
  },
  watch: {
    options: {
      handler() {
        const {sortBy, sortDesc, page, itemsPerPage} = this.options
        this.setPage(page)
        this.setFieldSort(sortBy[0])
        this.setPageSize(itemsPerPage)
        this.setSort(sortDesc[0])
        this.fetch()
      },
      deep: true
    }
  },
  computed: {
    isSelectedBranch() {
      return this.filterHospital !== ''
    },
    showSearchAndFilter() {
      return this.isSelectedBranch && this.tabItems[this.tab] === tabEnum.LIST
    },
    tabItems() {
      return Object.values(tabEnum)
    },
    snackbarSuccess() {
      return snackbarSuccessContent(this.pageName, this.snackTitle)
    },
    snackbarFail() {
      return snackbarFailContent(this.pageName, this.snackTitle)
    },
    selectedBranch() {
      let selectedBranch = null
      if (this.filterHospital !== '') {
        selectedBranch = this.filterHospital
      }
      return selectedBranch
    },
    branches() {
      return this.orgObject.map(o => o.value)
    },
    ...mapState('symptomaticAreas', [
      'isEditOrder',
      'symptomaticAreasList',
      'symptomaticAreasObject',
      'editOrderObject',
      'filterHospital',
      'isLoading',
      'isLoadingBranch',
      'orgObject',
      'sortableList',
      'total'
    ])
  },
  mounted() {
    let query = this.$route.query.isCreateSuccess
    let querySnackTitle = this.$route.query.snackTitle
    if (query) {
      this.$router.replace({})
      this.isCreateSuccess = query
      this.snackTitle = querySnackTitle
    }

    this.setViewOrgInfo()
  },
  destroyed() {
    this.resetState()
    this.resetList()
    this.setFilterHospital('')
  },
  methods: {
    create() {
      this.$router.push({
        name: 'symptomatic-areas-create'
      })
    },
    resetSearchAndFilterData() {
      this.options.page = 1
      this.componentKey++
      this.filters.searchPhase = ''
      this.resetSearchAndFilter()
    },
    changedSelectedBranch(value) {
      if (value.length > 0) {
        this.resetSearchAndFilterData()
        this.setFilterHospital(value[0])
        this.fetchByTab(this.tab)
      }
    },
    async saveEditOrder(data) {
      this.setShowEditOrder(false)
      const {oldOrderNo, newOrderNo} = data
      const newOrderList = swapArrayElements(
        this.sortableList,
        oldOrderNo - 1,
        newOrderNo - 1
      )
      await this.reorderSymptomaticAreasList(newOrderList)
      this.showSuccessSnackbar(actionEnum.ORDER_UPDATED)
    },
    async fetchByTab(data) {
      this.resetSearchAndFilterData()
      if (this.tabItems[data] === tabEnum.SORT) {
        await this.fetchSortableList()
      }
      if (this.tabItems[data] === tabEnum.LIST) {
        await this.fetch()
      }
    },
    handleApplyFilter() {
      this.options.page = 1
    },
    closeEditOrder() {
      this.setShowEditOrder(false)
    },
    showSuccessSnackbar(action) {
      this.isCreateSuccess = true
      this.snackTitle = action
    },
    showFailSnackbar(action) {
      this.isCreateFail = true
      this.snackTitle = action
    },
    onResize() {
      this.windowSize = {x: window.innerWidth, y: window.innerHeight}
    },
    hasPermCreate() {
      return hasPermision('CanAddSymptomatic')
    },
    hasPermEdit() {
      return hasPermision('CanEditSymptomatic')
    },
    hasPermDelete() {
      return hasPermision('CanDeleteSymptomatic')
    },
    hasPermEditByOrg(org) {
      const codenames = org.hasOwnProperty('org_codename') ? org.org_codename : []
      return hasPermissionsByOrgs('CanEditSymptomatic', codenames)
    },
    hasPermDeleteByOrg(org) {
      const codenames = org.hasOwnProperty('org_codename') ? org.org_codename : []
      return hasPermissionsByOrgs('CanDeleteSymptomatic', codenames)
    },
    clearSearch() {
      this.setTextSearch('')
      this.options.page = 1
      this.fetch()
    },
    textSearch(data) {
      this.filters.searchPhase = data
      this.timer = searchHandler(this.timer, clearTimeout, async () => {
        this.setTextSearch(
          this.filters.searchPhase ? this.filters.searchPhase.trim() : ''
        )
        this.options.page = 1
        await this.fetch()
      })
    },
    statusText(status) {
      return this.statusLookup[status]
    },
    statusColor(status) {
      return this.colorsLookup[status]
    },
    dateFmt: date => convertDate(date),
    getContentByLang(contents, lang) {
      const contentsInLang = contents.filter(c => c.code === lang)
      if (contentsInLang.length > 0) {
        return contentsInLang[0].name
      }
      return ''
    },
    listBranch(org) {
      return org.hasOwnProperty('org_codename') ? org.org_codename.toUpperCase() : ''
    },
    async handleSwitchStatusChange(event, id) {
      const isSuccess = await this.changeStatus({status: event, id: id})
      if (isSuccess) {
        this.showSuccessSnackbar(actionEnum.STATUS_UPDATED)
      } else {
        this.showFailSnackbar(actionEnum.STATUS_UPDATED)
      }
    },
    actionEdit(item) {
      this.resetState()
      this.$router.push({name: 'symptomatic-areas-edit', params: {id: item.id}})
    },
    async actionDelete(item) {
      this.objectDelete = item
      this.deleteId = item.id
      this.isDelete = true
    },
    async confirmDialog() {
      this.setDeleteId(this.deleteId)
      const isSuccess = await this.deletePkg(this.deleteId)
      this.deleteId = ''
      this.isDelete = false
      if (isSuccess) {
        this.fetch()
        this.showSuccessSnackbar(actionEnum.REMOVED)
      } else {
        this.showFailSnackbar(actionEnum.REMOVED)
      }
    },
    closeDialog() {
      this.deleteId = ''
      this.setDeleteId(this.deleteId)
      this.isDelete = false
    },
    ...mapActions('symptomaticAreas', [
      'changeStatus',
      'deletePkg',
      'fetch',
      'fetchSortableList',
      'reorderSymptomaticAreasList',
      'resetList',
      'resetSearchAndFilter',
      'resetState',
      'setDeleteId',
      'setSymptomaticAreasId',
      'setFieldSort',
      'setFilterHospital',
      'setPage',
      'setPageSize',
      'setShowEditOrder',
      'setSort',
      'setTextSearch',
      'setViewOrgInfo'
    ])
  },

  data() {
    return {
      pageName: 'Symptomatic Areas',
      heightOptions: {
        header: 420,
        tableFooter: 59
      },
      windowSize: {
        x: 0,
        y: 0
      },
      componentKey: 0,
      isCreateSuccess: false,
      isCreateFail: false,
      snackTitle: '',
      actionEnumData: actionEnum,
      filters: {
        searchPhase: ''
      },
      activeStatus: symptomaticAreasStatusEnum.ACTIVE,
      inActiveStatus: symptomaticAreasStatusEnum.INACTIVE,
      options: {},
      hospitalRules: [v => !!v || 'Branch is required'],
      objectDelete: {},
      buttonConfirmText: 'Remove',
      subTitle:
        'This content will be deleted in both Thai and English.\nAre you sure you want to delete this content?',
      deleteId: '',
      isDelete: false,
      colorsLookup: {
        0: 'green',
        1: 'red',
        2: 'yellow accent-4'
      },
      statusLookup: {
        0: 'Active',
        1: 'Inactive',
        2: 'Waiting'
      },
      tab: 0,
      table: {
        page: 1,
        pageSize: 25,
        itemPerPages: [25, 50, 100],
        activeHeaders: [
          {
            text: 'Name',
            align: 'left',
            sortable: false,
            value: 'content',
            width: 288
          },
          {
            text: 'Branch',
            align: 'left',
            sortable: false,
            value: 'org',
            width: 110
          },
          {
            text: 'Updated By',
            align: 'left',
            sortable: false,
            value: 'update_by_user',
            width: 162
          },
          {
            text: 'Updated date/time',
            align: 'left',
            sortable: false,
            value: 'update_date',
            width: 196
          },
          {
            text: 'Status',
            align: 'center',
            sortable: false,
            value: 'status',
            width: 114
          },
          {
            text: 'Actions',
            align: 'center',
            sortable: false,
            value: 'actions',
            width: 140
          }
        ]
      },
      breadcrumbs: [
        {text: 'Department Management', disabled: true, link: false},
        {
          text: 'Symptomatic Areas',
          disabled: true,
          link: true,
          to: '/'
        }
      ]
    }
  }
}
</script>

<style scoped></style>